<template>
  <yue-dialog :title="title" :visible.sync="visible" width="700px">
    <div class="modal-container">
      <div class="modal-header">
        <div>
          <template v-if="schoolAllReport&&schoolAllReport.state">
            <el-button type="primary" size="small" :disabled="schoolAllReport.state == 1" @click="clickItem('createReadMarkExport', { type: 'create', row: schoolAllReport })" v-if="schoolAllReport.state != 2">一键生成</el-button>
            <el-button type="primary" size="small" v-if="schoolAllReport.state == 2" @click="downloadSchoolAllReport">一键下载</el-button>
          </template>
        </div>

        <div class="export-header">
          <span>点击刷新查看导出进度</span>
          <el-button type="primary" size="small" @click="clickItem('exportData', false)">刷新</el-button>
        </div>
      </div>

      <div class="export-summary">
        <el-table v-loading="reportLoading" :data="reportList" size="mini">
          <el-table-column prop="fileName" label="报表名称">
            <template slot-scope="scope">
              <div style="display: flex;flex-wrap: wrap;">
                <div style="width:100%">{{ scope.row.fileName }}</div>
                <template v-if="scope.row.category.indexOf('SIX_RATE')>-1 && showSixRete">
                  <el-checkbox-group v-model="checkSixRateList" @change="clickItem('checkSixRate', checkSixRateList,false)">
                    <el-checkbox v-for="(type, index) in sixRateList" :key="`export-${index}`" :label="type.value">
                      {{ type.name }}</el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-if="scope.row.category.indexOf('SCORE_DETAIL') > -1 && showQuestionScorel">
                  <el-checkbox-group v-model="checkQuestionScorelList" @change="clickItem('checkQuestionScorel', checkQuestionScorelList,false)">
                    <el-checkbox v-for="(type, index) in subsectionScoreConfig" :key="`export-${index}`" :label="type.value">
                      {{ type.name }}</el-checkbox>
                  </el-checkbox-group>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="state" label="导出状态">
            <template slot-scope="scope">
              <span v-if="scope.row.state + '' === '0'">等待处理</span>
              <span v-else-if="scope.row.state + '' === '1'">处理中</span>
              <span v-else-if="scope.row.state + '' === '2'">已完成</span>
              <span v-else-if="scope.row.state + '' === '3'">处理失败</span>
              <span v-else>未导出</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <div class="btn-group">
                <el-button type="text" v-if="scope.row.state === null || scope.row.state + '' === '0'" @click="clickItem('createReadMarkExport', { type: 'create', row: scope.row })">导出</el-button>
                <el-button type="text" :style="`color:${scope.row.state + '' === '3' ? 'red' : ''};`" v-if="scope.row.state + '' === '2' || scope.row.state + '' === '3'" @click="clickItem('createReadMarkExport', { type: 'refresh', row: scope.row })">重新导出</el-button>
                <template v-if="scope.row.state + '' === '2'">
                  <a :href="scope.row.url" download>
                    <el-button type="text">Excel下载</el-button>
                  </a>
                  <a v-if="scope.row.pdfUrl" :href="scope.row.pdfUrl" download target="_blank">
                    <el-button type="text">Pdf下载</el-button>
                  </a>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </yue-dialog>
</template>

<script>
import { reportData } from '@/v2/utils/data';

export default {
  name: 'ExportModal',
  props: {
    title: {
      type: String,
      default: () => '导出报表'
    },
    reportList: {
      type: Array,
      default: () => []
    },
    schoolAllReport: {
      type: Object,
      default: () => { }
    },
    showSixRete: {
      type: Boolean,
      default: () => true
    },
    showQuestionScorel: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    reportListData () {
      return this.reportList.map(item => {
        item.category = item.category.join(',')
        return item
      })
    }
  },
  data () {
    return {
      visible: false,
      reportLoading: false,
      sixRateList: reportData.getSixRate(),
      subsectionScoreConfig: [ ],
      checkSixRateList: [],
      checkQuestionScorelList: [],
    }
  },

  methods: {
    open (checkSixRateList = [], checkQuestionScorelList = []) {
      this.checkSixRateList = checkSixRateList
      this.checkQuestionScorelList = checkQuestionScorelList
      this.visible = true
      this.reportLoading = false
    },
    clickItem: function (method, params, isLoading = true) {
      if (isLoading) {
        this.reportLoading = true
      }

      this.$emit('click-item', { method, params })
    },
    downloadSchoolAllReport () {
      window.open(this.schoolAllReport.url)
    }
  }
}
</script>

<style scoped lang="scss">
.modal-container {
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
  }

  .report-tab {
    position: relative;
    height: 32px;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      height: 2px;
      width: 70px;
      background-color: $color-theme;
      transition: transform 0.2s;
    }

    &.active-2 {
      &::after {
        transform: translateX(87px);
      }
    }

    .tab-item {
      user-select: none;
      display: inline-block;
      height: 32px;
      line-height: 30px;
      margin-right: 12px;

      &.is-active {
        color: $color-theme;
      }

      &:not(.is-active) {
        cursor: pointer;
      }
    }
  }

  .export-header {
    text-align: right;

    span {
      color: #999;
      font-size: 14px;
      padding-right: 10px;
    }
  }

  .export-summary {
    h4 {
      height: 32px;
      line-height: 32px;
      font-weight: bold;
    }

    .summary-checkbox {
      border-bottom: 1px solid #eee;
      padding-bottom: 20px;

      .checkbox-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }

    .summary-record {
      margin-top: 20px;
    }

    .el-checkbox {
      margin-bottom: 10px;
    }
  }
}

.btn-group {
  ::v-deep .el-button {
    padding: 2px 10px;
  }
}
</style>